import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { CookieService } from 'ngx-cookie-service';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

import { FuseMatchMediaService } from '@fuse/services/match-media.service';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
import { FavorisFacade } from './favoris/favoris.facade';
import { Favoris } from './favoris/favoris.model';
import { UserFacade } from 'app/main/user/user.facade';
import { User } from 'app/main/user/user.model';
import { Criteria } from 'app/shared/utils/criteria.model';
import { SearchCriteria } from 'app/shared/utils/searchCriteria';
import { SearchCriteriaGroup } from 'app/shared/utils/searchCriteriaGroup';
import { TranslateService } from '@ngx-translate/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { locale as English } from '../shortcuts/favoris/i18n/en';
import { locale as French } from '../shortcuts/favoris/i18n/fr';
@Component({
    selector: 'fuse-shortcuts',
    templateUrl: './shortcuts.component.html',
    styleUrls: ['./shortcuts.component.scss']
})
export class FuseShortcutsComponent implements OnInit, AfterViewInit, OnDestroy {
    shortcutItems: any[];
    navigationItems: any[];
    favoris: Favoris;
    filteredNavigationItems: any[];
    searching: boolean;
    mobileShortcutsPanelActive: boolean;
    favoriss$: Observable<Favoris[]>;

    parentMap: Map<string, any> = new Map();
    user$: Observable<User>;
    user: User;
    @Input()
    navigation: any;

    @ViewChild('searchInput')
    searchInputField;

    @ViewChild('shortcuts')
    shortcutsEl: ElementRef;

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {CookieService} _cookieService
     * @param {FuseMatchMediaService} _fuseMatchMediaService
     * @param {FuseNavigationService} _fuseNavigationService
     * @param {MediaObserver} _mediaObserver
     * @param {Renderer2} _renderer
     */
    constructor(
        private _userFacade: UserFacade,
        private _favorisFacade: FavorisFacade,
        private _fuseMatchMediaService: FuseMatchMediaService,
        private _fuseNavigationService: FuseNavigationService,
        private _mediaObserver: MediaObserver,
        private _translateLoaderService: FuseTranslationLoaderService,
        private _renderer: Renderer2,
        private _translateService: TranslateService) {
            this._translateLoaderService.loadTranslations(English, French);
        // Set the defaults
        this.shortcutItems = [];
        this.searching = false;
        this.mobileShortcutsPanelActive = false;

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
       

        this.favoris = new Favoris();
        // Get the navigation items and flatten them
        this.filteredNavigationItems = this.navigationItems = this._fuseNavigationService.getFlatNavigation(this.navigation);
        this.buildParentMap(this.navigation);

        this._favorisFacade.loadAll();
        this.favoriss$ = this._favorisFacade.all$;
        this._userFacade
            .getCurrentUser()
            .subscribe((user) => (this.user = user));

    }
    buildParentMap(items: any[], parent: any = null): void {
        for (const item of items) {
            if (parent) {
                this.parentMap.set(item.id, parent);
            }
            if (item.children) {
                this.buildParentMap(item.children, item);
            }
        }
    }

    ngAfterViewInit(): void {
        this.favoriss$
        .subscribe(shortcutItem => {
            this.shortcutItems = shortcutItem;
            this.shortcutItems.map(favoris => (typeof favoris.shortcutItem === 'string')?  favoris.shortcutItem = JSON.parse(favoris.shortcutItem): favoris.shortcutItem );
        });
        // Subscribe to media changes
        this._fuseMatchMediaService.onMediaChange
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(() => {
                if (this._mediaObserver.isActive('gt-sm')) {
                    this.hideMobileShortcutsPanel();
                }
            });

    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Search
     *
     * @param event
     */
    search(event): void {
        const value = event.target.value.toLowerCase();

        if (value === '') {
            this.searching = false;
            this.filteredNavigationItems = this.navigationItems;

            return;
        }

        this.searching = true;

        this.filteredNavigationItems = this.navigationItems.filter((navigationItem) => {
            return navigationItem.title.toLowerCase().includes(value);
        });
    }




    getFullPath(navigationItem): string {
        let path = '';
        let parent = this.parentMap.get(navigationItem.id);
        const visited = new Set(); // Pour éviter les boucles infinies
    
        while (parent) {
            if (visited.has(parent.id)) {
                console.warn('Boucle détectée dans parentMap pour id:', parent.id);
                break; // Évite une boucle infinie
            }
    
            visited.add(parent.id);
            path = (path ? ' / ' : '/') + parent.title + path;
            parent = this.parentMap.get(parent.id);
        }
    
        return path;
    }
    

    /**
     * Toggle shortcut
     *
     * @param event
     * @param itemToToggle
     */
    toggleShortcut(event, itemToToggle): void {
        event.stopPropagation();

        let i = 0;
        let existsFavorie = false;
        let lengthlist = this.shortcutItems.length
        while (i < lengthlist) {
            //let criteria: Criteria = new Criteria();
           // criteria.filter = [new SearchCriteriaGroup([new SearchCriteria('user', '=', this.user.id)])];
    
          
            if (this.shortcutItems[i] && this.shortcutItems[i].shortcutItem.url === itemToToggle.url) {
               console.log(this.shortcutItems[i]);
                this._favorisFacade.delete(this.shortcutItems[i]);
                existsFavorie = true;
                break;
                return;
            }
            i++;
        }
        if (existsFavorie === false) {
            this.favoris.shortcutItem = JSON.stringify(itemToToggle);
            this.favoris.user = this.user
            this._favorisFacade.create(this.favoris)
        }
    }

    /**
     * Is in shortcuts?
     *
     * @param navigationItem
     * @returns {any}
     */
    isInShortcuts(navigationItem): any {
        return this.shortcutItems.find(item => {
            return item.shortcutItem.url === navigationItem.url;
        });
    }

    /**
     * On menu open
     */
    onMenuOpen(): void {
        setTimeout(() => {
            this.searchInputField.nativeElement.focus();
        });
    }

    /**
     * Show mobile shortcuts
     */
    showMobileShortcutsPanel(): void {
        this.mobileShortcutsPanelActive = true;
        this._renderer.addClass(this.shortcutsEl.nativeElement, 'show-mobile-panel');
    }

    /**
     * Hide mobile shortcuts
     */
    hideMobileShortcutsPanel(): void {
        this.mobileShortcutsPanelActive = false;
        this._renderer.removeClass(this.shortcutsEl.nativeElement, 'show-mobile-panel');
    }
}
